var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSqlDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M51.395 24.879c-27.422 0-49.649-3.832-49.649-8.535v92.261c0 4.727 22.227 8.536 49.649 8.536 27.421 0 49.648-3.832 49.648-8.536V16.29c0 4.758-22.227 8.59-49.648 8.59Zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#adadad",
    d: "M1.746 16.29v92.315c0 4.727 22.227 8.536 49.649 8.536V24.879c-27.422 0-49.649-3.832-49.649-8.59Zm92.317 4.405v92.262c4.425-1.277 6.98-2.777 6.98-4.375V16.289c0 1.633-2.547 3.106-6.98 4.406Zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#939699",
    d: "M101.043 16.313c0-4.723-22.23-8.555-49.648-8.555-27.422 0-49.649 3.832-49.649 8.555 0 4.726 22.227 8.558 49.649 8.558 27.417 0 49.648-3.832 49.648-8.558ZM1.746 74.332c0 4.727 22.227 8.535 49.649 8.535 27.421 0 49.648-3.832 49.648-8.535v6.984c0 4.723-22.227 8.532-49.648 8.532-27.422 0-49.649-3.832-49.649-8.532Zm0-30.75c0 4.723 22.227 8.535 49.649 8.535 27.421 0 49.648-3.836 49.648-8.535v6.98c0 4.727-22.227 8.536-49.648 8.536-27.422 0-49.649-3.832-49.649-8.535Zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecedf0",
    d: "M126.64 93.09c0 16.281-13.195 29.48-29.476 29.48s-29.48-13.199-29.48-29.48 13.199-29.477 29.48-29.477 29.477 13.196 29.477 29.477Zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3faa00",
    d: "M123.004 93.09c0 14.273-11.57 25.84-25.84 25.84-14.273 0-25.84-11.567-25.84-25.84 0-14.27 11.567-25.84 25.84-25.84 14.27 0 25.84 11.57 25.84 25.84Zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m88.063 105.906 24.027-13.87-24.028-13.872Zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlDev);
export default __webpack_public_path__ + "static/media/SQLDev.943d9de65c8719d201080514f3ab0f67.svg";
export { ForwardRef as ReactComponent };